import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

/** Label column + control column (see RaiseTicketPage). */
export default function FormRow({ label, hint, children, last }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "180px 1fr" },
        gap: { xs: 1, md: 3.5 },
        py: 2.25,
        borderBottom: last ? "none" : `1px solid ${theme.palette.brand.border}`,
      }}
    >
      <Box>
        <Box sx={{ fontSize: 14, fontWeight: 600, color: theme.palette.brand.ink }}>{label}</Box>
        {hint ? (
          <Box
            sx={{
              fontSize: 12,
              color: theme.palette.brand.inkSoft,
              mt: 0.5,
              lineHeight: 1.45,
            }}
          >
            {hint}
          </Box>
        ) : null}
      </Box>
      <Box>{children}</Box>
    </Box>
  );
}

/** Bordered form shell shared with raise-ticket and client portal forms. */
export function BrandFormCard({ title, children, sx }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.brand.border}`,
        borderRadius: "8px",
        p: { xs: 3, md: "28px 32px" },
        ...sx,
      }}
    >
      {title ? (
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1.5 }}>
          {title}
        </Typography>
      ) : null}
      {children}
    </Box>
  );
}
